import {InjectionToken} from "@angular/core";

export interface LfmExpressApiModuleConfig {
  apiUrl?: string;
}

export const LFM_EXPRESS_API_MODULE_CONFIG = new InjectionToken('LfmExpressApiModuleConfig');
